module.exports = __webpack_public_path__ + "/login_ui/img/sy-9c0c367e5e3a03d3d8287aaa95971b97.svg";